import { render, staticRenderFns } from "./FrequencyDataChart.vue?vue&type=template&id=5b823540&scoped=true&"
import script from "./FrequencyDataChart.vue?vue&type=script&lang=js&"
export * from "./FrequencyDataChart.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyDataChart.vue?vue&type=style&index=0&id=5b823540&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b823540",
  null
  
)

export default component.exports